import React from 'react';

import StyledButtonRow from './styled/StyledButtonRow';

export const ButtonRow = ({ children, column = false }) => {
  return <StyledButtonRow $column={column}>{children}</StyledButtonRow>;
};
